import React from 'react';
import Icon from '../../../components/AppIcon';

const APIHealthPanel = ({ apiHealth }) => {
  const getHealthIcon = (available) => {
    return available ? 'CheckCircle2' : 'XCircle';
  };

  const getHealthColor = (available) => {
    return available ? 'success' : 'error';
  };

  const formatResponseTime = (ms) => {
    if (ms === 0) return 'N/A';
    return `${ms}ms`;
  };

  const apis = [
    { name: 'OpenAI', key: 'openai', icon: 'Sparkles' },
    { name: 'Gemini', key: 'gemini', icon: 'Zap' },
    { name: 'Anthropic', key: 'anthropic', icon: 'Brain' },
    { name: 'Groq', key: 'groq', icon: 'Cpu' }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-6 space-y-4">
      <div className="flex items-center gap-3">
        <div className="flex items-center justify-center w-12 h-12 rounded-lg bg-primary/10">
          <Icon name="Activity" size={24} color="var(--color-primary)" />
        </div>
        <div>
          <h3 className="font-semibold text-foreground">Saúde das APIs</h3>
          <p className="text-xs text-muted-foreground">Monitoramento de serviços de IA</p>
        </div>
      </div>

      <div className="space-y-3">
        {apis?.map((api) => {
          const health = apiHealth?.[api?.key];
          const healthColor = getHealthColor(health?.available);
          const healthIcon = getHealthIcon(health?.available);

          return (
            <div key={api?.key} className="p-4 rounded-lg bg-muted/30 space-y-3">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <Icon name={api?.icon} size={18} className="text-muted-foreground" />
                  <span className="text-sm font-medium text-foreground">{api?.name}</span>
                </div>
                <div className="flex items-center gap-2">
                  <Icon 
                    name={healthIcon} 
                    size={16} 
                    color={`var(--color-${healthColor})`}
                  />
                  <span 
                    className="text-xs font-semibold"
                    style={{ color: `var(--color-${healthColor})` }}
                  >
                    {health?.available ? 'Online' : 'Offline'}
                  </span>
                </div>
              </div>

              <div className="grid grid-cols-3 gap-2">
                <div>
                  <p className="text-xs text-muted-foreground">Resposta</p>
                  <p className="text-sm font-semibold text-foreground">
                    {formatResponseTime(health?.responseTime)}
                  </p>
                </div>
                <div>
                  <p className="text-xs text-muted-foreground">Rate Limit</p>
                  <p className="text-sm font-semibold text-foreground">
                    {health?.rateLimit || 0}%
                  </p>
                </div>
                <div>
                  <p className="text-xs text-muted-foreground">Erros</p>
                  <p className="text-sm font-semibold text-foreground">
                    {health?.errorFrequency || 0}
                  </p>
                </div>
              </div>

              {/* Response Time Graph (simplified) */}
              {health?.available && health?.responseTime > 0 && (
                <div className="w-full h-1.5 bg-muted rounded-full overflow-hidden">
                  <div 
                    className="h-full bg-primary transition-smooth"
                    style={{ 
                      width: `${Math.min((health?.responseTime / 2000) * 100, 100)}%` 
                    }}
                  />
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default APIHealthPanel;